import * as React from 'react';

import styles from './trial-gathering-prompt.module.css';

type Props = {
    children: React.ReactNode;
};

export function TrialGatheringPrompt(props: Props) {
    return <div className={styles['prompt']}>{props.children}</div>;
}
